<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [hideUserName]="context == 'candidate'">
    <i scActivityIcon class="fa-sharp fa-solid fa-bolt"></i>
    @if (context == 'candidate') {
    {{ texts.poolSignalCandidateContext[language] }}
    } @else {
    <span scActivityPrefix>{{ texts.poolSignalPrefix[language] }}</span>
    }
    <div scActivityBody>
        <p class="mb-0 oneline"><span class="text-muted"><i class="fa-sharp fa-solid fa-bolt"></i> {{ texts.poolSignalSignal[language] }}:</span> {{ activity.Payload?.Signal }}</p>
        <p class="oneline"><span class="text-muted"><i class="fa-sharp fa-solid fa-stars"></i> {{ texts.poolSignalAction[language] }}:</span> {{ activity.Payload?.Action }}</p>
    </div>
</sc-activity-list-item>
